<template>
  <div class="delivery-border-table">
    <div class="border-lists">
      <div class="qty-bg">
        <h6>{{ _T('Qty') }}</h6>
      </div>
      <div class="food-box">
        <h6>{{ _T('Food Name') }}</h6>
      </div>
      <div class="price-box">
        <h6>{{ _T('Price') }}</h6>
      </div>
    </div>
    <order-item
      v-for="(orderItem, index) in orderItems"
      :key="index"
      :order-item="orderItem"
      :item-modifiers="itemModifiers"
      :item-discounts="itemDiscounts"
    />
  </div>
</template>

<script>
import OrderItem from './OrderItem'
import { mapGetters } from 'vuex'
export default {
  name: 'OrderItems',
  props: {
    orderItems: {
      type: Array,
      default () {
        return []
      },
    },
    itemModifiers: {
      type: Array,
      default () {
        return []
      },
    },
    itemDiscounts: {
      type: Array,
      default () {
        return []
      },
    },
  },
  components: {
    OrderItem,
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss" scoped>
.delivery-border-table {
  padding: $px40 0 $px20;
  border-top: $px1 solid $light-border;
  .border-lists {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    border: $px1 solid $light-border;
    border-radius: $px4;
    overflow: hidden;
    &:first-child {
      border: none;
    }
    > div {
      width: 100%;
      h6 {
        font-weight: 600;
        line-height: $px17;
        color: $light-font;
        text-transform: uppercase;
        margin-bottom: 0;
      }
    }
    + .border-lists {
      margin-top: $px8;
      + .border-lists {
        margin-top: $px12;
      }
      .food-box {
        align-self: center;
        padding: $px10 0;
      }
      .price-box {
        align-self: center;
        text-align: center;
      }
    }
  }
}
</style>
